<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    width="1200px"
    custom-class="inventory-check-submit-dialog"
    :close-on-click-modal="false"
    append-to-body
    @close="handleClose"
  >
    <div class="submit-meta" v-if="meta.planId">
      <span>盘库单号：{{ meta.planId }}</span>
      <span>计划日期：{{ meta.planDate || "-" }}</span>
      <span>状态：{{ meta.statusLabel || "-" }}</span>
    </div>

    <el-tabs v-model="listTab" class="book-qty-tabs">
      <el-tab-pane v-if="mode === 'review'" name="diffNonzero">
        <span slot="label">偏差!=0（{{ diffNonzeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane v-if="mode === 'review'" name="diffZero">
        <span slot="label">偏差=0（{{ diffZeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane name="nonzero">
        <span slot="label">本地库存!=0（{{ nonzeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane name="zero">
        <span slot="label">本地库存=0（{{ zeroCount }}）</span>
      </el-tab-pane>
      <el-tab-pane name="all">
        <span slot="label">全部（{{ allCount }}）</span>
      </el-tab-pane>
    </el-tabs>

    <el-table
      :data="filteredSkuList"
      border
      stripe
      size="mini"
      max-height="460"
      show-summary
      :summary-method="getSummaries"
      v-loading="loading"
      element-loading-text="加载中..."
    >
      <el-table-column label="序号" width="50" align="center">
        <template slot-scope="scope">{{ scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column prop="shopName" label="店铺" width="70" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="productName" label="产品名称" min-width="120" show-overflow-tooltip></el-table-column>
      <el-table-column prop="purchaseColorName" label="采购颜色" width="90" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="sku" label="SKU" min-width="170" show-overflow-tooltip></el-table-column>
      <el-table-column prop="bookQty" label="本地库存数量" width="100" align="right"></el-table-column>
      <el-table-column prop="checkQty" label="盘库数量" width="110" align="center">
        <template slot-scope="scope">
          <el-input
            v-if="editable"
            type="number"
            size="mini"
            v-model="scope.row.checkQty"
            @input="onCheckQtyInput(scope.row)"
          ></el-input>
          <span v-else>{{ scope.row.checkQty }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="diffQty" label="偏差" width="80" align="right">
        <template slot-scope="scope">
          <span :class="{ 'diff-positive': scope.row.diffQty > 0, 'diff-negative': scope.row.diffQty < 0 }">
            {{ scope.row.diffQty }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="偏差原因" min-width="160">
        <template slot-scope="scope">
          <el-input
            size="mini"
            maxlength="200"
            clearable
            placeholder="请输入偏差原因"
            v-model="scope.row.remark"
          ></el-input>
        </template>
      </el-table-column>
    </el-table>

    <div class="remark-row">
      <span class="remark-label">备注</span>
      <el-input
        type="textarea"
        :rows="2"
        size="small"
        maxlength="500"
        show-word-limit
        :disabled="!editable"
        v-model="remark"
        placeholder="请输入备注"
      ></el-input>
    </div>

    <div class="diff-summary" v-if="mode === 'review' && skuList.length">
      <span>偏差合计：{{ totalDiffQty }}</span>
      <span>盘盈行：{{ gainCount }}</span>
      <span>盘亏行：{{ lossCount }}</span>
      <span>无偏差行：{{ zeroDiffCount }}</span>
    </div>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">关 闭</el-button>
      <template v-if="mode === 'submit'">
        <el-button type="primary" size="small" :loading="submitting" @click="onSubmit">确认盘库</el-button>
      </template>
      <template v-else-if="mode === 'review'">
        <el-button size="small" :loading="rejecting" :disabled="confirming" @click="onReject">打回</el-button>
        <el-button type="primary" size="small" :loading="confirming" :disabled="rejecting" @click="onConfirmDiff">
          确认偏差
        </el-button>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import request from "../../request/requestModules.js";
import { getInventoryCheckStatusLabel } from "./inventoryCheckStatus.js";

export default {
  name: "SubmitInventoryCheckDialog",
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      rejecting: false,
      confirming: false,
      mode: "submit", // submit | review
      inventoryCheckId: "",
      skuList: [],
      listTab: "nonzero",
      remark: "",
      meta: {},
    };
  },
  computed: {
    dialogTitle() {
      return this.mode === "review" ? "确认库存偏差" : "确认盘库";
    },
    editable() {
      return this.mode === "submit";
    },
    nonzeroCount() {
      return (this.skuList || []).filter(row => Number(row.bookQty) !== 0).length;
    },
    zeroCount() {
      return (this.skuList || []).filter(row => Number(row.bookQty) === 0).length;
    },
    allCount() {
      return (this.skuList || []).length;
    },
    diffNonzeroCount() {
      return (this.skuList || []).filter(row => Number(row.diffQty) !== 0).length;
    },
    diffZeroCount() {
      return (this.skuList || []).filter(row => Number(row.diffQty) === 0).length;
    },
    filteredSkuList() {
      const list = this.skuList || [];
      if (this.listTab === "diffNonzero") {
        return list.filter(row => Number(row.diffQty) !== 0);
      }
      if (this.listTab === "diffZero") {
        return list.filter(row => Number(row.diffQty) === 0);
      }
      if (this.listTab === "zero") {
        return list.filter(row => Number(row.bookQty) === 0);
      }
      if (this.listTab === "all") {
        return list;
      }
      return list.filter(row => Number(row.bookQty) !== 0);
    },
    totalDiffQty() {
      return (this.skuList || []).reduce((sum, row) => sum + (Number(row.diffQty) || 0), 0);
    },
    gainCount() {
      return (this.skuList || []).filter(row => Number(row.diffQty) > 0).length;
    },
    lossCount() {
      return (this.skuList || []).filter(row => Number(row.diffQty) < 0).length;
    },
    zeroDiffCount() {
      return (this.skuList || []).filter(row => Number(row.diffQty) === 0).length;
    },
  },
  methods: {
    open(row, mode = "submit") {
      if (!row || !(row.id || row._id)) {
        this.$message.warning("请选择盘库计划");
        return;
      }
      this.mode = mode === "review" ? "review" : "submit";
      this.inventoryCheckId = String(row.id || row._id);
      this.listTab = this.mode === "review" ? "diffNonzero" : "nonzero";
      this.dialogVisible = true;
      this.meta = {
        planId: row.planId || "",
        planDate: row.planDate || "",
        statusLabel: row.statusLabel || getInventoryCheckStatusLabel(row.status),
      };
      this.remark = row.remark || "";
      this.loadDetails();
    },
    handleClose() {
      this.skuList = [];
      this.remark = "";
      this.meta = {};
      this.inventoryCheckId = "";
      this.listTab = "nonzero";
      this.submitting = false;
      this.rejecting = false;
      this.confirming = false;
    },
    loadDetails() {
      this.loading = true;
      request
        .fetchInventoryCheckDetails({
          id: this.inventoryCheckId,
          beginIndex: 0,
          pageSize: 100000,
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "获取盘库明细失败");
            this.skuList = [];
            return;
          }
          if (res.mdata) {
            this.meta = {
              ...this.meta,
              planId: res.mdata.planId || this.meta.planId,
              planDate: res.mdata.planDate || this.meta.planDate,
              statusLabel: res.mdata.statusLabel || this.meta.statusLabel,
            };
            if (res.mdata.remark != null) {
              this.remark = res.mdata.remark;
            }
          }
          this.skuList = (res.ldata || []).map(row => {
            const bookQty = row.bookQty != null ? Number(row.bookQty) : 0;
            const hasCheck = row.checkQty != null && row.checkQty !== "";
            const checkQty = hasCheck ? Number(row.checkQty) : bookQty;
            return {
              ...row,
              id: row.id || (row._id ? String(row._id) : ""),
              bookQty,
              checkQty,
              diffQty: checkQty - bookQty,
              remark: row.remark != null ? String(row.remark) : "",
            };
          });
          if (!this.skuList.length) {
            this.$message.info("暂无盘库明细");
          }
        })
        .catch(err => {
          this.$message.error((err && err.message) || "获取盘库明细失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onCheckQtyInput(row) {
      const text = String(row.checkQty == null ? "" : row.checkQty).trim();
      if (text === "" || text === "-") {
        row.diffQty = 0 - Number(row.bookQty || 0);
        return;
      }
      if (text.includes(".")) {
        this.$message.warning("盘库数量不允许小数");
        row.checkQty = String(parseInt(text, 10));
      }
      const n = parseInt(row.checkQty, 10);
      if (Number.isNaN(n)) {
        row.diffQty = "";
        return;
      }
      row.checkQty = n;
      row.diffQty = n - Number(row.bookQty || 0);
    },
    validateLines() {
      for (let i = 0; i < this.skuList.length; i++) {
        const row = this.skuList[i];
        const text = String(row.checkQty == null ? "" : row.checkQty).trim();
        if (text === "") {
          this.$message.warning(`第 ${i + 1} 行请填写盘库数量`);
          return false;
        }
        if (text.includes(".")) {
          this.$message.warning(`SKU「${row.sku}」盘库数量不允许小数`);
          return false;
        }
        const n = Number(text);
        if (!Number.isInteger(n) || n < 0) {
          this.$message.warning(`SKU「${row.sku}」盘库数量须为不小于 0 的整数`);
          return false;
        }
      }
      return true;
    },
    onSubmit() {
      if (!this.validateLines()) return;
      this.submitting = true;
      request
        .submitInventoryCheck({
          id: this.inventoryCheckId,
          remark: this.remark,
          lines: this.skuList.map(row => ({
            id: row.id,
            sku: row.sku,
            checkQty: Number(row.checkQty),
            remark: row.remark != null ? String(row.remark).trim() : "",
          })),
        })
        .then(res => {
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "确认盘库失败");
            return;
          }
          this.$message.success("已提交，进入待确认库存偏差");
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(err => {
          this.$message.error((err && err.message) || "确认盘库失败");
        })
        .finally(() => {
          this.submitting = false;
        });
    },
    onReject() {
      if (this.rejecting || this.confirming) return;
      this.$confirm("确认打回盘库中，可重新修改盘库数量？", "提示", {
        confirmButtonText: "确定打回",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.rejecting = true;
          return request.rejectInventoryCheckDiff({ id: this.inventoryCheckId });
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$message.error(res.message || "打回失败");
            return;
          }
          this.$message.success("已打回盘库中");
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          this.$message.error((err && err.message) || "打回失败");
        })
        .finally(() => {
          this.rejecting = false;
        });
    },
    onConfirmDiff() {
      if (this.rejecting || this.confirming) return;
      const tip =
        this.gainCount + this.lossCount > 0
          ? `将按非零偏差生成库存调整（盘盈 ${this.gainCount} 行 / 盘亏 ${this.lossCount} 行），状态变为已盘库。是否确认？`
          : "当前无偏差行，确认后将变为已盘库且不生成库存调整。是否确认？";
      this.$confirm(tip, "确认偏差", {
        confirmButtonText: "确认偏差",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirming = true;
          return request.confirmInventoryCheckDiff({
            id: this.inventoryCheckId,
            lines: this.skuList.map(row => ({
              id: row.id,
              sku: row.sku,
              remark: row.remark != null ? String(row.remark).trim() : "",
            })),
          });
        })
        .then(res => {
          if (!res) return;
          if (res.result != 1 && res.code != 0) {
            this.$alert(res.message || "确认偏差失败", "无法确认偏差", {
              type: "error",
              confirmButtonText: "知道了",
            });
            return;
          }
          const planId = (res.mdata && res.mdata.adjustPlanId) || "";
          this.$message.success(planId ? `已确认偏差，调整单号 ${planId}` : "已确认偏差");
          this.dialogVisible = false;
          this.$emit("success");
        })
        .catch(err => {
          if (err === "cancel" || (err && err === "close")) return;
          this.$message.error((err && err.message) || "确认偏差失败");
        })
        .finally(() => {
          this.confirming = false;
        });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "bookQty" || column.property === "checkQty" || column.property === "diffQty") {
          sums[index] = (data || []).reduce((s, row) => s + (Number(row[column.property]) || 0), 0);
          return;
        }
        sums[index] = "";
      });
      return sums;
    },
  },
};
</script>

<style lang="scss">
.inventory-check-submit-dialog {
  .submit-meta {
    margin-bottom: 10px;
    font-size: 13px;
    color: #606266;
    span {
      margin-right: 16px;
    }
  }
  .book-qty-tabs {
    margin-bottom: 8px;
    .el-tabs__header {
      margin-bottom: 8px;
    }
  }
  .remark-row {
    margin-top: 12px;
    display: flex;
    align-items: flex-start;
    .remark-label {
      width: 48px;
      line-height: 32px;
      color: #606266;
    }
    .el-textarea {
      flex: 1;
    }
  }
  .diff-summary {
    margin-top: 10px;
    font-size: 13px;
    color: #606266;
    span {
      margin-right: 16px;
    }
  }
  .diff-positive {
    color: #67c23a;
  }
  .diff-negative {
    color: #f56c6c;
  }
}
</style>
